import { DateFormatter } from '@repo/toolkit/date'

import { tripStepTypeMapping } from '../../types/enums/trip/trip-type.enum'
import { TripProperties } from '../../types/models/trip/properties.trip'
import { TripFolder } from '../../types/models/trip-folder/trip-folder'

/** "26/10/2026 - Aller - Paris - Angleterre - Eurostar" (date - directionality - trips) */
export function getTripFolderLabel(
  tripFolder: Pick<TripFolder, 'date' | 'directionality' | 'trips'>
) {
  return [
    DateFormatter.DDMMYYYY(tripFolder.date, { i18n: false }),
    tripStepTypeMapping[tripFolder.directionality]?.label,
    tripFolder.trips.map((trip) => TripProperties.getTripLabel(trip)).join(', ')
  ]
    .filter(Boolean)
    .join(' - ')
}
